module.exports = __webpack_public_path__ + "static/media/proactive_logo.75c27b30.png";